import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from "../../client-server-common/doppe-action-types/doppe-action-type";
import {DoppeActionTypeContentSpecialSettingsMetadata} from "../../client-server-common";

export const doppeActionTypeDebugApi = doppeActionTypeDefineMetadata({
    id: 'io.bymo.action/debug/api',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({}),
    actionSettingsMetadata: {
        contentSettingsMetadata: DoppeActionTypeContentSpecialSettingsMetadata.Ignored,
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {},
        bindableContentSettingsNames: {}
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: false
})